import { ModalServiceInterface } from 'pf-frontend-common/dist/service/modal/service.interface';
import { EventEmitterInterface } from 'pf-frontend-common/src/module/event/emitter.interface';

import { BackendConfigSettingsInterface } from 'common/data/backend/config/settings.interface';
import { settingsGetPageType } from 'common/helper/settings/get-page-type';
import { DataStore } from 'common/module/data/store';
import { LeadSignInStatsGtmLabelEnum } from 'common/module/lead/sign-in/stats/gtm/label.enum';
import { LeadSignInStatsGtmNotNowClick } from 'common/module/lead/sign-in/stats/gtm/not-now-click';
import { LeadSignInTemplatePropsInterface } from 'common/module/lead/sign-in/template-props.interface';
import { StatsGtmProviderInterface } from 'common/module/stats/gtm/provider.interface';
import { StatsTealiumDataLayerEventReferenceEnum } from 'common/module/stats/tealium/data-layer/event-reference.enum';
import { UserAuthTrackerFactory } from 'common/module/user/auth/tracker.factory';
import { UserPopupServiceInterface } from 'common/service/user-popup/service.interface';
import { LeadPhoneViewStore } from 'mobile/module/lead/phone/view-store';

export class LeadSignInViewStore extends DataStore {
  /**
   * @inheritDoc
   */
  protected state: LeadSignInTemplatePropsInterface;

  /**
   * Gtm label for cta buttons
   */
  private gtmLabel: LeadSignInStatsGtmLabelEnum;

  /**
   * Constructor
   */
  constructor(
    eventEmitter: EventEmitterInterface,
    private userPopupService: UserPopupServiceInterface,
    private statsGtm: StatsGtmProviderInterface,
    private modalService: ModalServiceInterface,
    private settings: BackendConfigSettingsInterface,
    private leadPhoneService: LeadPhoneViewStore
  ) {
    super(eventEmitter);
  }

  /**
   * @inheritDoc
   */
  public initialize(options: { gtmLabel: LeadSignInStatsGtmLabelEnum }): void {
    this.gtmLabel = options.gtmLabel;

    this.state = {
      isVisible: false,
      isNotNowButtonHidden: false,
      onClickNotNow: this.onClickNotNow,
      onClickSignIn: this.onClickSignIn,
      onClose: this.onClose,
    };
  }

  /**
   * set event reference of sign in popup
   */
  public setEventReference(eventReference: StatsTealiumDataLayerEventReferenceEnum): void {
    this.userPopupService.setEventReference(eventReference);
  }

  /**
   * @inheritdoc
   */
  public getState(): LeadSignInTemplatePropsInterface {
    return this.state;
  }

  /**
   * Click on 'sign in' button
   */
  private onClickSignIn = (): void => {
    UserAuthTrackerFactory().onLoginModalOpen(StatsTealiumDataLayerEventReferenceEnum.POST_CALL_POPUP);
    this.modalService.close();
    this.leadPhoneService.openAuthPopup();
  };

  /**
   * Click on 'not now' button
   */
  private onClickNotNow = (): void => {
    this.statsGtm.send(LeadSignInStatsGtmNotNowClick(this.gtmLabel, settingsGetPageType(this.settings)));
    this.modalService.close();
  };

  private onClose = (): void => {
    this.modalService.close();
  };
}
